import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EnergyLabelComponent } from '~shared/modules/energy-label/components/energy-label/energy-label.component';
import { EecImageModalComponent } from '~shared/modules/energy-label/components';
import { MmFlexLayoutModule, MmIconModule } from '@metromarkets/components';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { RepairabilityLabelModule } from '../repairability-label';
import { EnergyDatasheetComponent } from './components/energy-datasheet/energy-datasheet.component';

@NgModule({
  declarations: [
    EnergyLabelComponent,
    EecImageModalComponent,
    EnergyDatasheetComponent
  ],
  imports: [
    CommonModule,
    MmIconModule,
    MatDialogModule,
    TranslateModule,
    MmFlexLayoutModule,
    RepairabilityLabelModule
  ],
  exports: [
    EnergyLabelComponent,
    EnergyDatasheetComponent
  ]
})
export class EnergyLabelModule {
}
